var map = {
	"./images/alter-ego/alter-ego-hero_cn.png": 592,
	"./images/alter-ego/alter-ego-hero_en.png": 593,
	"./images/alter-ego/alter-ego-hero_jp.png": 594,
	"./images/alter-ego/alter-ego-palette_cn.jpg": 595,
	"./images/alter-ego/alter-ego-palette_en.jpg": 596,
	"./images/alter-ego/alter-ego-palette_jp.jpg": 597,
	"./images/artprize/ap2020-result-logo-cn.png": 598,
	"./images/artprize/ap2020-result-logo.png": 599,
	"./images/artprize/ap2020-watermark-cn.png": 600,
	"./images/artprize/ap2020-watermark.png": 601,
	"./images/artprize/devs-choice-cn.png": 602,
	"./images/artprize/devs-choice.png": 603,
	"./images/artprize/grand-prize-cn.png": 604,
	"./images/artprize/grand-prize.png": 605,
	"./images/artprize/logo.png": 606,
	"./images/artprize/second-prize-cn.png": 607,
	"./images/artprize/second-prize.png": 608,
	"./images/artprize/student-grand-prize-cn.png": 609,
	"./images/artprize/student-grand-prize.png": 610,
	"./images/artprize/student-second-prize-cn.png": 611,
	"./images/artprize/student-second-prize.png": 612,
	"./images/artprize/waterfall-mask-image-cn.png": 613,
	"./images/artprize/waterfall-mask-image-en.png": 614,
	"./images/artprize/works-we-love-cn.png": 615,
	"./images/artprize/works-we-love.png": 616,
	"./images/badges/ada-badge-2013_cn.svg": 617,
	"./images/badges/ada-badge-2013_en.svg": 618,
	"./images/badges/ada-badge-2013_jp.svg": 619,
	"./images/badges/ada-badge-2022_cn.svg": 620,
	"./images/badges/ada-badge-2022_en.svg": 621,
	"./images/badges/ada-badge-2022_jp.svg": 622,
	"./images/badges/iphone-aoty-2018-dark_cn.svg": 623,
	"./images/badges/iphone-aoty-2018_en.svg": 624,
	"./images/badges/iphone-aoty-2018_jp.svg": 625,
	"./images/beginners-series/part-four-thumb.jpg": 626,
	"./images/beginners-series/part-four-thumb_mobile.jpg": 627,
	"./images/beginners-series/part-one-thumb.jpg": 628,
	"./images/beginners-series/part-one-thumb_mobile.jpg": 629,
	"./images/beginners-series/part-three-thumb.jpg": 630,
	"./images/beginners-series/part-three-thumb_mobile.jpg": 631,
	"./images/beginners-series/part-two-thumb.jpg": 632,
	"./images/beginners-series/part-two-thumb_mobile.jpg": 633,
	"./images/beginners-series/play.svg": 634,
	"./images/beginners-series/squig1.png": 635,
	"./images/beginners-series/squig2-2.png": 636,
	"./images/beginners-series/squig3.png": 637,
	"./images/beginners-series/squig4.png": 638,
	"./images/credit-thumbnails/ipad/127-fish.jpg": 639,
	"./images/credit-thumbnails/ipad/aaron-griffin-neon.jpg": 640,
	"./images/credit-thumbnails/ipad/aaron-griffin-sketch-series-1.jpg": 641,
	"./images/credit-thumbnails/ipad/aaron-griffin-sketch-series.jpg": 642,
	"./images/credit-thumbnails/ipad/aaron-griffin-untitled.jpg": 643,
	"./images/credit-thumbnails/ipad/acky-bright-attack.jpg": 644,
	"./images/credit-thumbnails/ipad/agiel-untitled.jpg": 645,
	"./images/credit-thumbnails/ipad/al-jerek-torrijas-saved-by-the-bell.jpg": 646,
	"./images/credit-thumbnails/ipad/alexis-franklin-untitled-2.jpg": 647,
	"./images/credit-thumbnails/ipad/alexis-franklin-untitled.jpg": 648,
	"./images/credit-thumbnails/ipad/andrew-pena-echo-park.jpg": 649,
	"./images/credit-thumbnails/ipad/andrew-pena-san-gabriele-canyon.jpg": 650,
	"./images/credit-thumbnails/ipad/andrey-malykh-untitled.jpg": 651,
	"./images/credit-thumbnails/ipad/angela-sung-car.jpg": 652,
	"./images/credit-thumbnails/ipad/angela-sung-light-and-dark.jpg": 653,
	"./images/credit-thumbnails/ipad/angela-sung-pasadena.jpg": 654,
	"./images/credit-thumbnails/ipad/angela-sung-tramline.jpg": 655,
	"./images/credit-thumbnails/ipad/arash-razavi-tawny.jpg": 656,
	"./images/credit-thumbnails/ipad/arnandhita-agiel-untitled.jpg": 657,
	"./images/credit-thumbnails/ipad/asli-narin-untitled.jpg": 658,
	"./images/credit-thumbnails/ipad/asuka111-geisha.jpg": 659,
	"./images/credit-thumbnails/ipad/asuka111-glitch.jpg": 660,
	"./images/credit-thumbnails/ipad/asuka111-the-cat-caravan.jpg": 661,
	"./images/credit-thumbnails/ipad/ayan-nag-hut.jpg": 662,
	"./images/credit-thumbnails/ipad/ayan-nag-midnight-gleam.jpg": 663,
	"./images/credit-thumbnails/ipad/ayan-nag-red-sand.jpg": 664,
	"./images/credit-thumbnails/ipad/ayan-nag-valley.jpg": 665,
	"./images/credit-thumbnails/ipad/ayan_nag-frosty-glaze.jpg": 666,
	"./images/credit-thumbnails/ipad/bastien-grivet-the-door.jpg": 667,
	"./images/credit-thumbnails/ipad/chantal-horeis-untitled.jpg": 668,
	"./images/credit-thumbnails/ipad/chelsea-blecha-bungalow.jpg": 669,
	"./images/credit-thumbnails/ipad/christiane-king-another-untitled.jpg": 670,
	"./images/credit-thumbnails/ipad/christiane-king-untitled.jpg": 671,
	"./images/credit-thumbnails/ipad/christiane-king-working-portrait.jpg": 672,
	"./images/credit-thumbnails/ipad/dani-diez-desert-seeker.jpg": 673,
	"./images/credit-thumbnails/ipad/danni-fisher-shin-reality-filter.jpg": 674,
	"./images/credit-thumbnails/ipad/deborah-lee-untitled.jpg": 675,
	"./images/credit-thumbnails/ipad/donglongdong-wondertown.jpg": 676,
	"./images/credit-thumbnails/ipad/eliza-ivanova-mask-and-moon.jpg": 677,
	"./images/credit-thumbnails/ipad/eliza-ivanova-untitled.jpg": 678,
	"./images/credit-thumbnails/ipad/enrique-figueroa-princess-uakamayatl.jpg": 679,
	"./images/credit-thumbnails/ipad/even-amundsen-the_deepwoods.jpg": 680,
	"./images/credit-thumbnails/ipad/even-amundsen-untitled.jpg": 681,
	"./images/credit-thumbnails/ipad/fatemeh-haghnejad-explorers.jpeg": 682,
	"./images/credit-thumbnails/ipad/giles-ketting-unknown.jpg": 683,
	"./images/credit-thumbnails/ipad/godwin-akpan-all-a-blur.jpg": 684,
	"./images/credit-thumbnails/ipad/goro-fujita-enoki-tales.jpg": 685,
	"./images/credit-thumbnails/ipad/guangyuan-beast.jpg": 686,
	"./images/credit-thumbnails/ipad/ilya-kuvshinov-fox.jpg": 687,
	"./images/credit-thumbnails/ipad/ilya-kuvshinov-untitled.jpg": 688,
	"./images/credit-thumbnails/ipad/ivan-belikov-guitar.jpg": 689,
	"./images/credit-thumbnails/ipad/ivan-belikov-parus.jpg": 690,
	"./images/credit-thumbnails/ipad/jarom-vogel-monkey.jpg": 691,
	"./images/credit-thumbnails/ipad/jarom-vogel-natures-dance.jpg": 692,
	"./images/credit-thumbnails/ipad/jarom-vogel-untitled.jpg": 693,
	"./images/credit-thumbnails/ipad/jaye-kang-secret-of-foxes.jpg": 694,
	"./images/credit-thumbnails/ipad/jaye-kang-xuanwu.jpg": 695,
	"./images/credit-thumbnails/ipad/jhonny-nunez-desert.jpg": 696,
	"./images/credit-thumbnails/ipad/kael-escape.jpg": 697,
	"./images/credit-thumbnails/ipad/kika-klat-untitled.jpg": 698,
	"./images/credit-thumbnails/ipad/lois-van-baarle-petals.jpg": 699,
	"./images/credit-thumbnails/ipad/lucas-wakamatsu-leopard.jpg": 700,
	"./images/credit-thumbnails/ipad/marija-tiurina-the-breakfast-cart.jpg": 701,
	"./images/credit-thumbnails/ipad/max-ulichney-believers.jpg": 702,
	"./images/credit-thumbnails/ipad/max-ulichney-explorers.jpg": 703,
	"./images/credit-thumbnails/ipad/max-ulichney-scuba.jpg": 704,
	"./images/credit-thumbnails/ipad/michael-relth-untitled.jpg": 705,
	"./images/credit-thumbnails/ipad/michal-sawtyruk-day-out.jpg": 706,
	"./images/credit-thumbnails/ipad/micheal-relth-little-birdy.jpg": 707,
	"./images/credit-thumbnails/ipad/mike-mccain-adventure-bound.jpg": 708,
	"./images/credit-thumbnails/ipad/mingjue-helen-chen-parkillo.jpg": 709,
	"./images/credit-thumbnails/ipad/mohammed-fazil-shoe.jpg": 710,
	"./images/credit-thumbnails/ipad/nick-liefhebber-creativity-and-the-arts.jpg": 711,
	"./images/credit-thumbnails/ipad/nick-liefhebber-wild-flower.jpg": 712,
	"./images/credit-thumbnails/ipad/nikko-80s.jpg": 713,
	"./images/credit-thumbnails/ipad/nikolai-lockertsen-office-field-of-dreams.jpg": 714,
	"./images/credit-thumbnails/ipad/nikolai-lockertsen-office.jpg": 715,
	"./images/credit-thumbnails/ipad/nikolai-lockertsen-river-view.jpg": 716,
	"./images/credit-thumbnails/ipad/nikolai-lockertsen-transendence.jpg": 717,
	"./images/credit-thumbnails/ipad/nikolai-lockertsen-walk-the-dog.jpg": 718,
	"./images/credit-thumbnails/ipad/nuwarhol-untitled.jpg": 719,
	"./images/credit-thumbnails/ipad/paperboi-goodie.jpg": 720,
	"./images/credit-thumbnails/ipad/paperboi-untitled.jpg": 721,
	"./images/credit-thumbnails/ipad/patrick-okeefe-running-late.jpg": 722,
	"./images/credit-thumbnails/ipad/pauline-vos-the-kiss.jpg": 723,
	"./images/credit-thumbnails/ipad/pauline-vos-untitled.jpg": 724,
	"./images/credit-thumbnails/ipad/rebecca-mills-little-help.jpg": 725,
	"./images/credit-thumbnails/ipad/rune-fisker-dearly-departed.jpg": 726,
	"./images/credit-thumbnails/ipad/sam-nassour-iggy.jpg": 727,
	"./images/credit-thumbnails/ipad/sam-nassour-leopard.jpg": 728,
	"./images/credit-thumbnails/ipad/sam-nassour-untitled.jpg": 729,
	"./images/credit-thumbnails/ipad/sam-rodriguez-nectar.jpg": 730,
	"./images/credit-thumbnails/ipad/sam-rodriguez-untitled.jpg": 731,
	"./images/credit-thumbnails/ipad/sam-rodriquez-skateboard.jpg": 732,
	"./images/credit-thumbnails/ipad/sam-rodriquez-untitled-2.jpg": 733,
	"./images/credit-thumbnails/ipad/sami-halim-jungle.jpg": 734,
	"./images/credit-thumbnails/ipad/sami-halim-untitled.jpg": 735,
	"./images/credit-thumbnails/ipad/sang-wook-kim-the-danced-all-night.jpg": 736,
	"./images/credit-thumbnails/ipad/saroush-barazesh-kings-of-nowhere.jpg": 737,
	"./images/credit-thumbnails/ipad/satoma-untitled.jpg": 738,
	"./images/credit-thumbnails/ipad/sau-koinobori.jpg": 739,
	"./images/credit-thumbnails/ipad/sean-edwards-entourage.jpg": 740,
	"./images/credit-thumbnails/ipad/shannon-king-together-we-rise.jpg": 741,
	"./images/credit-thumbnails/ipad/stephane-bourez-alien-panther.jpg": 742,
	"./images/credit-thumbnails/ipad/stephane-bourez-escapee.jpg": 743,
	"./images/credit-thumbnails/ipad/stephane-bourez-forest-discovery.jpg": 744,
	"./images/credit-thumbnails/ipad/stephane-bourez-mech.jpg": 745,
	"./images/credit-thumbnails/ipad/tom-everingham-cut-out.jpg": 746,
	"./images/credit-thumbnails/ipad/tom-haugomat-french-riviera.jpg": 747,
	"./images/credit-thumbnails/ipad/wanjie-li-untitled.jpg": 748,
	"./images/credit-thumbnails/ipad/will-robinson-old-mage.jpg": 749,
	"./images/credit-thumbnails/ipad/will-robinson-rampage.jpg": 750,
	"./images/credit-thumbnails/ipad/zutto-evolution.jpg": 751,
	"./images/credit-thumbnails/ipad/zutto-fizzy.jpg": 752,
	"./images/credit-thumbnails/ipad/zutto-the-wave.jpg": 753,
	"./images/credit-thumbnails/pocket/127-lion-dance-lying-down.jpg": 754,
	"./images/credit-thumbnails/pocket/aaron-griffin-drift.jpg": 755,
	"./images/credit-thumbnails/pocket/andrew-pena-big-bear-trees.jpg": 756,
	"./images/credit-thumbnails/pocket/andrew-pena-descanso-creek.jpg": 757,
	"./images/credit-thumbnails/pocket/angela-sung-in-the-garden.jpg": 758,
	"./images/credit-thumbnails/pocket/angela-sung-on-tokyo-streets.jpg": 759,
	"./images/credit-thumbnails/pocket/asuka111-koi.jpg": 760,
	"./images/credit-thumbnails/pocket/dani-diez-untitled.jpg": 761,
	"./images/credit-thumbnails/pocket/danni-fisher-shin-lone-warrior.jpg": 762,
	"./images/credit-thumbnails/pocket/goro-fujita-the-lantern-maker.jpg": 763,
	"./images/credit-thumbnails/pocket/janice-sung-lush.jpg": 764,
	"./images/credit-thumbnails/pocket/jarom-vogel-powerful-stuff.jpg": 765,
	"./images/credit-thumbnails/pocket/jaye-kang-be-special.jpg": 766,
	"./images/credit-thumbnails/pocket/jaye-kang-flower-maker.jpg": 767,
	"./images/credit-thumbnails/pocket/max-ulichney-caldera.jpg": 768,
	"./images/credit-thumbnails/pocket/monez-guzmang-early-bird.jpg": 769,
	"./images/credit-thumbnails/pocket/nick-liefhebber-leaving-home.jpg": 770,
	"./images/credit-thumbnails/pocket/nick-liefhebber-the-galaxy-knows.jpg": 771,
	"./images/credit-thumbnails/pocket/randy-barias-untitled.jpg": 772,
	"./images/credit-thumbnails/pocket/rebecca-mills-hello-fish-friends.jpg": 773,
	"./images/credit-thumbnails/pocket/samy-halim-martin-day.jpg": 774,
	"./images/credit-thumbnails/pocket/samy-halim-martin-night.jpg": 775,
	"./images/credit-thumbnails/pocket/sara-lee-chromatic-jungle.jpg": 776,
	"./images/credit-thumbnails/pocket/siyi-chen-im-feline-fine.jpg": 777,
	"./images/credit-thumbnails/pocket/siyi-chen-sun-shower.jpg": 778,
	"./images/credit-thumbnails/pocket/zutto-new-places.jpg": 779,
	"./images/credit-thumbnails/pocket/zutto-pink-dragons.jpg": 780,
	"./images/employment/cluster1.jpg": 781,
	"./images/employment/cluster2.jpg": 782,
	"./images/employment/cluster3.jpg": 783,
	"./images/employment/tassie1.jpg": 784,
	"./images/employment/tassie2.jpg": 785,
	"./images/employment/tassie3.jpg": 786,
	"./images/favicon/android-icon-144x144.png": 787,
	"./images/favicon/android-icon-192x192.png": 788,
	"./images/favicon/android-icon-36x36.png": 789,
	"./images/favicon/android-icon-48x48.png": 790,
	"./images/favicon/android-icon-72x72.png": 791,
	"./images/favicon/android-icon-96x96.png": 792,
	"./images/favicon/apple-icon-114x114.png": 793,
	"./images/favicon/apple-icon-120x120.png": 794,
	"./images/favicon/apple-icon-152x152.png": 795,
	"./images/favicon/apple-icon-57x57.png": 796,
	"./images/favicon/apple-icon-60x60.png": 797,
	"./images/favicon/apple-icon-72x72.png": 798,
	"./images/favicon/apple-icon-76x76.png": 799,
	"./images/favicon/apple-icon-precomposed.png": 800,
	"./images/favicon/apple-icon.png": 801,
	"./images/favicon/favicon-16x16.png": 802,
	"./images/favicon/favicon-32x32.png": 803,
	"./images/favicon/favicon-96x96.png": 804,
	"./images/favicon/favicon.ico": 805,
	"./images/favicon/manifest": 356,
	"./images/favicon/manifest.json": 356,
	"./images/favicon/ms-icon-144x144.png": 806,
	"./images/favicon/ms-icon-150x150.png": 807,
	"./images/favicon/ms-icon-310x310.png": 808,
	"./images/favicon/ms-icon-70x70.png": 809,
	"./images/flags/en-US.png": 810,
	"./images/flags/ja.png": 811,
	"./images/flags/zh-CN.png": 812,
	"./images/handbook/handbook-explosion_cn.jpg": 813,
	"./images/handbook/handbook-explosion_en.jpg": 814,
	"./images/handbook/handbook-explosion_jp.jpg": 815,
	"./images/home/masonry/3d-desktop_cn.jpg": 816,
	"./images/home/masonry/3d-desktop_en.jpg": 817,
	"./images/home/masonry/3d-desktop_jp.jpg": 818,
	"./images/home/masonry/3d-mobile_cn.jpg": 819,
	"./images/home/masonry/3d-mobile_en.jpg": 820,
	"./images/home/masonry/3d-mobile_jp.jpg": 821,
	"./images/home/masonry/3d-tablet_cn.jpg": 822,
	"./images/home/masonry/3d-tablet_en.jpg": 823,
	"./images/home/masonry/3d-tablet_jp.jpg": 824,
	"./images/home/masonry/a11y-mobile.jpg": 825,
	"./images/home/masonry/a11y.jpg": 826,
	"./images/home/masonry/careers-tile-mobile.jpg": 827,
	"./images/home/masonry/careers-tile.jpg": 828,
	"./images/home/masonry/edu-tablet.jpg": 829,
	"./images/home/masonry/education-mobile.jpg": 830,
	"./images/home/masonry/education.jpg": 831,
	"./images/home/masonry/folio-mobile.jpg": 832,
	"./images/home/masonry/folio-tablet.jpg": 833,
	"./images/home/masonry/folio.jpg": 834,
	"./images/home/masonry/pocket-mobile_cn.jpg": 835,
	"./images/home/masonry/pocket-mobile_en.jpg": 836,
	"./images/home/masonry/pocket-mobile_jp.jpg": 837,
	"./images/home/masonry/pocket-tablet_cn.jpg": 838,
	"./images/home/masonry/pocket-tablet_en.jpg": 839,
	"./images/home/masonry/pocket-tablet_jp.jpg": 840,
	"./images/home/masonry/pocket_cn.jpg": 841,
	"./images/home/masonry/pocket_en.jpg": 842,
	"./images/home/masonry/pocket_jp.jpg": 843,
	"./images/home/masonry/whats-new-53.jpg": 844,
	"./images/home/procreate-53-frame.png": 845,
	"./images/ipad/3d/ar-view.jpg": 846,
	"./images/ipad/3d/ar-view_blur.jpg": 847,
	"./images/ipad/3d/lighting-studio_cn.jpg": 848,
	"./images/ipad/3d/lighting-studio_en.jpg": 849,
	"./images/ipad/3d/lighting-studio_jp.jpg": 850,
	"./images/ipad/3d/materials-2_cn.jpg": 851,
	"./images/ipad/3d/materials-2_en.jpg": 852,
	"./images/ipad/3d/materials-2_jp.jpg": 853,
	"./images/ipad/3d/materials_cn.jpg": 854,
	"./images/ipad/3d/materials_en.jpg": 855,
	"./images/ipad/3d/materials_jp.jpg": 856,
	"./images/ipad/a11y-cta-bg.jpg": 333,
	"./images/ipad/a11y/a11y-color-naming-1_cn.jpg": 857,
	"./images/ipad/a11y/a11y-color-naming-1_en.jpg": 858,
	"./images/ipad/a11y/a11y-color-naming-1_jp.jpg": 859,
	"./images/ipad/a11y/a11y-large-text-1_cn.jpg": 860,
	"./images/ipad/a11y/a11y-large-text-1_en.jpg": 861,
	"./images/ipad/a11y/a11y-large-text-1_jp.jpg": 862,
	"./images/ipad/a11y/a11y-onionskin_cn.jpg": 863,
	"./images/ipad/a11y/a11y-onionskin_en.jpg": 864,
	"./images/ipad/a11y/a11y-onionskin_jp.jpg": 865,
	"./images/ipad/a11y/a11y-stability-1_cn.jpg": 866,
	"./images/ipad/a11y/a11y-stability-1_en.jpg": 867,
	"./images/ipad/a11y/a11y-stability-1_jp.jpg": 868,
	"./images/ipad/a11y/a11y-stability-2_cn.jpg": 869,
	"./images/ipad/a11y/a11y-stability-2_en.jpg": 870,
	"./images/ipad/a11y/a11y-stability-2_jp.jpg": 871,
	"./images/ipad/a11y/a11y-support_cn.jpg": 872,
	"./images/ipad/a11y/a11y-support_en.jpg": 873,
	"./images/ipad/a11y/a11y-support_jp.jpg": 874,
	"./images/ipad/brush-studio_cn.jpg": 875,
	"./images/ipad/brush-studio_en.jpg": 876,
	"./images/ipad/brush-studio_jp.jpg": 877,
	"./images/ipad/brushes/abr_cn.jpg": 878,
	"./images/ipad/brushes/abr_en.jpg": 879,
	"./images/ipad/brushes/abr_jp.jpg": 880,
	"./images/ipad/brushes/brushes-cn-2.jpg": 881,
	"./images/ipad/brushes/brushes-cn-3.jpg": 882,
	"./images/ipad/brushes/brushes-cn-5.jpg": 883,
	"./images/ipad/brushes/brushes-cn-hero.jpg": 884,
	"./images/ipad/brushes/brushes-en-3.jpg": 885,
	"./images/ipad/brushes/brushes-en-4.jpg": 886,
	"./images/ipad/brushes/brushes-en-6.jpg": 887,
	"./images/ipad/brushes/brushes-en-hero.jpg": 888,
	"./images/ipad/brushes/brushes-jp-2.jpg": 889,
	"./images/ipad/brushes/brushes-jp-3.jpg": 890,
	"./images/ipad/brushes/brushes-jp-4.jpg": 891,
	"./images/ipad/brushes/brushes-jp-hero.jpg": 892,
	"./images/ipad/brushes/brushes-left_cn.jpg": 893,
	"./images/ipad/brushes/brushes-left_en.jpg": 894,
	"./images/ipad/brushes/brushes-left_jp.jpg": 895,
	"./images/ipad/brushes/make-brushes-1_cn.jpg": 896,
	"./images/ipad/brushes/make-brushes-1_en.jpg": 897,
	"./images/ipad/brushes/make-brushes-1_jp.jpg": 898,
	"./images/ipad/brushes/make-brushes-2_cn.jpg": 899,
	"./images/ipad/brushes/make-brushes-2_en.jpg": 900,
	"./images/ipad/brushes/make-brushes-2_jp.jpg": 901,
	"./images/ipad/brushes/whats-new-10_cn.jpg": 902,
	"./images/ipad/brushes/whats-new-10_en.jpg": 903,
	"./images/ipad/brushes/whats-new-10_jp.jpg": 904,
	"./images/ipad/brushes/whats-new-6_cn.jpg": 905,
	"./images/ipad/brushes/whats-new-6_en.jpg": 906,
	"./images/ipad/brushes/whats-new-6_jp.jpg": 907,
	"./images/ipad/brushes/whats-new-7_cn.jpg": 908,
	"./images/ipad/brushes/whats-new-7_en.jpg": 909,
	"./images/ipad/brushes/whats-new-7_jp.jpg": 910,
	"./images/ipad/color/color-balance_cn.jpg": 911,
	"./images/ipad/color/color-balance_en.jpg": 912,
	"./images/ipad/color/color-balance_jp.jpg": 913,
	"./images/ipad/color/color-companion-1_cn.jpg": 914,
	"./images/ipad/color/color-companion-1_en.jpg": 915,
	"./images/ipad/color/color-companion-1_jp.jpg": 916,
	"./images/ipad/color/color-companion-2_cn.jpg": 917,
	"./images/ipad/color/color-companion-2_en.jpg": 918,
	"./images/ipad/color/color-companion-2_jp.jpg": 919,
	"./images/ipad/color/color-dynamics-1_cn.jpg": 920,
	"./images/ipad/color/color-dynamics-1_en.jpg": 921,
	"./images/ipad/color/color-dynamics-1_jp.jpg": 922,
	"./images/ipad/color/color-dynamics-2_cn.jpg": 923,
	"./images/ipad/color/color-dynamics-2_en.jpg": 924,
	"./images/ipad/color/color-dynamics-2_jp.jpg": 925,
	"./images/ipad/color/palette-1-bg.jpg": 926,
	"./images/ipad/color/palette-1_fg_cn.jpg": 927,
	"./images/ipad/color/palette-1_fg_en.jpg": 928,
	"./images/ipad/color/palette-1_fg_jp.jpg": 929,
	"./images/ipad/color/palette-2-bg.jpg": 930,
	"./images/ipad/color/palette-2_fg_cn.jpg": 931,
	"./images/ipad/color/palette-2_fg_en.jpg": 932,
	"./images/ipad/color/palette-2_fg_jp.jpg": 933,
	"./images/ipad/color/palettes_cn.jpg": 934,
	"./images/ipad/color/palettes_en.jpg": 935,
	"./images/ipad/color/palettes_jp.jpg": 936,
	"./images/ipad/cutting-edge/boundingbox_cn.jpg": 937,
	"./images/ipad/cutting-edge/boundingbox_en.jpg": 938,
	"./images/ipad/cutting-edge/boundingbox_jp.jpg": 939,
	"./images/ipad/cutting-edge/cutting-edge-cn-3.jpg": 940,
	"./images/ipad/cutting-edge/cutting-edge-en-3.jpg": 941,
	"./images/ipad/cutting-edge/cutting-edge-jp-3.jpg": 942,
	"./images/ipad/cutting-edge/pencil-filter-left_cn.jpg": 943,
	"./images/ipad/cutting-edge/pencil-filter-left_en.jpg": 944,
	"./images/ipad/cutting-edge/pencil-filter-left_jp.jpg": 945,
	"./images/ipad/cutting-edge/pencil-filter-right_cn.jpg": 946,
	"./images/ipad/cutting-edge/pencil-filter-right_en.jpg": 947,
	"./images/ipad/cutting-edge/pencil-filter-right_jp.jpg": 948,
	"./images/ipad/cutting-edge/quickmenu_cn.jpg": 949,
	"./images/ipad/cutting-edge/quickmenu_en.jpg": 950,
	"./images/ipad/cutting-edge/quickmenu_jp.jpg": 951,
	"./images/ipad/cutting-edge/streamline_cn.jpg": 952,
	"./images/ipad/cutting-edge/streamline_en.jpg": 953,
	"./images/ipad/cutting-edge/streamline_jp.jpg": 954,
	"./images/ipad/cutting-edge/symmetry_cn.jpg": 955,
	"./images/ipad/cutting-edge/symmetry_en.jpg": 956,
	"./images/ipad/cutting-edge/symmetry_jp.jpg": 957,
	"./images/ipad/facepaint-1_cn.jpg": 958,
	"./images/ipad/facepaint-1_en.jpg": 959,
	"./images/ipad/facepaint-1_jp.jpg": 960,
	"./images/ipad/facepaint-4_cn.jpg": 961,
	"./images/ipad/facepaint-4_en.jpg": 962,
	"./images/ipad/facepaint-4_jp.jpg": 963,
	"./images/ipad/fontcontrol_cn.jpg": 964,
	"./images/ipad/fontcontrol_en.jpg": 965,
	"./images/ipad/fontcontrol_jp.jpg": 966,
	"./images/ipad/frames/ipad-frame-landscape.png": 320,
	"./images/ipad/frames/ipad-frame-portrait.png": 323,
	"./images/ipad/frames/ipad-sm-frame-landscape.png": 325,
	"./images/ipad/frames/ipad-sm-frame-portrait.png": 327,
	"./images/ipad/ideation-1_cn.jpg": 967,
	"./images/ipad/ideation-1_en.jpg": 968,
	"./images/ipad/ideation-1_jp.jpg": 969,
	"./images/ipad/ideation-2_cn.jpg": 970,
	"./images/ipad/ideation-2_en.jpg": 971,
	"./images/ipad/ideation-2_jp.jpg": 972,
	"./images/ipad/ipad-brush-diagram.jpg": 973,
	"./images/ipad/ipad-cn-11.jpg": 974,
	"./images/ipad/ipad-cn-13.jpg": 975,
	"./images/ipad/ipad-cn-2.jpg": 976,
	"./images/ipad/ipad-cn-3.jpg": 977,
	"./images/ipad/ipad-en-11.jpg": 978,
	"./images/ipad/ipad-en-13.jpg": 979,
	"./images/ipad/ipad-en-2.jpg": 980,
	"./images/ipad/ipad-en-3.jpg": 981,
	"./images/ipad/ipad-gestures-1.jpg": 982,
	"./images/ipad/ipad-gestures-2.jpg": 983,
	"./images/ipad/ipad-gestures-3.jpg": 984,
	"./images/ipad/ipad-jp-11.jpg": 985,
	"./images/ipad/ipad-jp-13.jpg": 986,
	"./images/ipad/ipad-jp-2.jpg": 987,
	"./images/ipad/ipad-jp-3.jpg": 988,
	"./images/ipad/placeholder-landscape.jpg": 989,
	"./images/ipad/placeholder-portrait.jpg": 990,
	"./images/ipad/shadows/shadow-landscape.png": 321,
	"./images/ipad/shadows/shadow-portrait.png": 324,
	"./images/ipad/shadows/shadow-pro-landscape-soft.png": 322,
	"./images/ipad/shadows/shadow-sm-landscape-150.png": 326,
	"./images/ipad/shadows/shadow-sm-landscape.png": 991,
	"./images/ipad/shadows/shadow-sm-portrait-150.png": 328,
	"./images/ipad/specialeffects-1_cn.jpg": 992,
	"./images/ipad/specialeffects-1_en.jpg": 993,
	"./images/ipad/specialeffects-1_jp.jpg": 994,
	"./images/ipad/specialeffects-2_cn.jpg": 995,
	"./images/ipad/specialeffects-2_en.jpg": 996,
	"./images/ipad/specialeffects-2_jp.jpg": 997,
	"./images/ipad/transformselect_cn.jpg": 998,
	"./images/ipad/transformselect_en.jpg": 999,
	"./images/ipad/transformselect_jp.jpg": 1000,
	"./images/ipad/video/privatelayer_cn.jpg": 1001,
	"./images/ipad/video/privatelayer_en.jpg": 1002,
	"./images/ipad/video/privatelayer_jp.jpg": 1003,
	"./images/ipad/video/video-cn-1.jpg": 1004,
	"./images/ipad/video/video-en-1.jpg": 1005,
	"./images/ipad/video/video-jp-1.jpg": 1006,
	"./images/ipad/whats-new-1_cn.jpg": 1007,
	"./images/ipad/whats-new-1_en.jpg": 1008,
	"./images/ipad/whats-new-1_jp.jpg": 1009,
	"./images/ipad/whats-new-2_cn.jpg": 1010,
	"./images/ipad/whats-new-2_en.jpg": 1011,
	"./images/ipad/whats-new-2_jp.jpg": 1012,
	"./images/ipad/whats-new/m2-icon.jpg": 1013,
	"./images/ipad/whats-new/m2_cn.jpg": 1014,
	"./images/ipad/whats-new/m2_en.jpg": 1015,
	"./images/ipad/whats-new/m2_jp.jpg": 1016,
	"./images/ipad/whats-new/materials_cn.jpg": 1017,
	"./images/ipad/whats-new/materials_en.jpg": 1018,
	"./images/ipad/whats-new/materials_jp.jpg": 1019,
	"./images/ipad/whats-new/whats-new-12_cn.jpg": 1020,
	"./images/ipad/whats-new/whats-new-12_en.jpg": 1021,
	"./images/ipad/whats-new/whats-new-12_jp.jpg": 1022,
	"./images/login-modal/login-art-1.jpg": 1023,
	"./images/login-modal/login-art-13.jpg": 1024,
	"./images/login-modal/login-art-2.jpg": 1025,
	"./images/login-modal/login-art-3.jpg": 1026,
	"./images/login-modal/login-art-4.jpg": 1027,
	"./images/login-modal/login-art-5.jpg": 1028,
	"./images/login-modal/login-art-6.jpg": 1029,
	"./images/metadata/3d_cn.jpg": 1030,
	"./images/metadata/3d_en.jpg": 1031,
	"./images/metadata/3d_jp.jpg": 1032,
	"./images/metadata/accessibility_cn.jpg": 1033,
	"./images/metadata/accessibility_en.jpg": 1034,
	"./images/metadata/accessibility_jp.jpg": 1035,
	"./images/metadata/allstar_cn.jpg": 1036,
	"./images/metadata/allstar_en.jpg": 1037,
	"./images/metadata/alter-ego_cn.jpg": 1038,
	"./images/metadata/alter-ego_en.jpg": 1039,
	"./images/metadata/alter-ego_jp.jpg": 1040,
	"./images/metadata/beginners-series.jpg": 1041,
	"./images/metadata/brushes_cn.jpg": 1042,
	"./images/metadata/brushes_en.jpg": 1043,
	"./images/metadata/brushes_jp.jpg": 1044,
	"./images/metadata/careers.jpg": 1045,
	"./images/metadata/color_cn.jpg": 1046,
	"./images/metadata/color_en.jpg": 1047,
	"./images/metadata/color_jp.jpg": 1048,
	"./images/metadata/default_cn.jpg": 1049,
	"./images/metadata/default_en.jpg": 1050,
	"./images/metadata/default_jp.jpg": 1051,
	"./images/metadata/faq_cn.jpg": 1052,
	"./images/metadata/faq_en.jpg": 1053,
	"./images/metadata/faq_jp.jpg": 1054,
	"./images/metadata/insight.jpg": 1055,
	"./images/metadata/ipad_cn.jpg": 1056,
	"./images/metadata/ipad_en.jpg": 1057,
	"./images/metadata/ipad_jp.jpg": 1058,
	"./images/metadata/meta-whats-new.jpg": 1059,
	"./images/metadata/og-image_handbook_cn.jpg": 1060,
	"./images/metadata/og-image_handbook_en.jpg": 1061,
	"./images/metadata/og-image_handbook_jp.jpg": 1062,
	"./images/metadata/og-image_handbook_pocket_cn.jpg": 1063,
	"./images/metadata/og-image_handbook_pocket_en.jpg": 1064,
	"./images/metadata/pocket_cn.jpg": 1065,
	"./images/metadata/pocket_en.jpg": 1066,
	"./images/metadata/privacy_cn.jpg": 1067,
	"./images/metadata/privacy_en.jpg": 1068,
	"./images/metadata/privacy_jp.jpg": 1069,
	"./images/metadata/superpowers_cn.jpg": 1070,
	"./images/metadata/superpowers_en.jpg": 1071,
	"./images/metadata/superpowers_jp.jpg": 1072,
	"./images/metadata/support_cn.jpg": 1073,
	"./images/metadata/support_en.jpg": 1074,
	"./images/metadata/support_jp.jpg": 1075,
	"./images/metadata/terms_cn.jpg": 1076,
	"./images/metadata/terms_en.jpg": 1077,
	"./images/metadata/terms_jp.jpg": 1078,
	"./images/metadata/video_cn.jpg": 1079,
	"./images/metadata/video_en.jpg": 1080,
	"./images/metadata/video_jp.jpg": 1081,
	"./images/pencil/pencil-alt-attached.png": 1082,
	"./images/pencil/pencil-alt-vertical.png": 1083,
	"./images/pencil/pencil-alt.png": 1084,
	"./images/pencil/pencil-flattened.png": 1085,
	"./images/pencil/pencil-no-shadow-alt.png": 1086,
	"./images/pencil/pencil-no-shadow.png": 1087,
	"./images/pencil/pencil-shadow.png": 1088,
	"./images/pencil/pencil.png": 1089,
	"./images/pocket/animation_en.jpg": 1090,
	"./images/pocket/animation_jp.jpg": 1091,
	"./images/pocket/big-boy.jpg": 1092,
	"./images/pocket/brushes-1_en.jpg": 1093,
	"./images/pocket/brushes-1_jp.jpg": 1094,
	"./images/pocket/brushes-2_en.jpg": 1095,
	"./images/pocket/brushes-2_jp.jpg": 1096,
	"./images/pocket/cn-bg-animate.png": 1097,
	"./images/pocket/cn-bg-brushes.png": 1098,
	"./images/pocket/cn-bg-color.png": 1099,
	"./images/pocket/cn-bg-hero.png": 1100,
	"./images/pocket/cn-bg-powers.png": 1101,
	"./images/pocket/cn-bg-transform.png": 1102,
	"./images/pocket/cn_pocket-1.jpg": 1103,
	"./images/pocket/cn_pocket-10.jpg": 1104,
	"./images/pocket/cn_pocket-11.jpg": 1105,
	"./images/pocket/cn_pocket-13.jpg": 1106,
	"./images/pocket/cn_pocket-14.jpg": 1107,
	"./images/pocket/cn_pocket-15.jpg": 1108,
	"./images/pocket/cn_pocket-16.jpg": 1109,
	"./images/pocket/cn_pocket-17.jpg": 1110,
	"./images/pocket/cn_pocket-18.jpg": 1111,
	"./images/pocket/cn_pocket-19.jpg": 1112,
	"./images/pocket/cn_pocket-2.jpg": 1113,
	"./images/pocket/cn_pocket-20.jpg": 1114,
	"./images/pocket/cn_pocket-21.jpg": 1115,
	"./images/pocket/cn_pocket-22.jpg": 1116,
	"./images/pocket/cn_pocket-3.jpg": 1117,
	"./images/pocket/cn_pocket-4.jpg": 1118,
	"./images/pocket/cn_pocket-5.jpg": 1119,
	"./images/pocket/cn_pocket-6.jpg": 1120,
	"./images/pocket/cn_pocket-7.jpg": 1121,
	"./images/pocket/cn_pocket-8.jpg": 1122,
	"./images/pocket/cn_pocket-9.jpg": 1123,
	"./images/pocket/color-1_en.jpg": 1124,
	"./images/pocket/color-2_en.jpg": 1125,
	"./images/pocket/color-2_jp.jpg": 1126,
	"./images/pocket/facepaint_en.jpg": 1127,
	"./images/pocket/facepaint_jp.jpg": 1128,
	"./images/pocket/filters-flat.jpg": 1129,
	"./images/pocket/filters_en.jpg": 1130,
	"./images/pocket/filters_jp.jpg": 1131,
	"./images/pocket/footer-1_en.jpg": 1132,
	"./images/pocket/footer-1_jp.jpg": 1133,
	"./images/pocket/footer-2_en.jpg": 1134,
	"./images/pocket/footer-2_jp.jpg": 1135,
	"./images/pocket/footer-3_en.jpg": 1136,
	"./images/pocket/frame-sprites/css_sprites-left-21.png": 340,
	"./images/pocket/frame-sprites/css_sprites-left-revised.png": 1137,
	"./images/pocket/frame-sprites/css_sprites-left.png": 1138,
	"./images/pocket/frame-sprites/css_sprites-right-21.png": 339,
	"./images/pocket/frame-sprites/css_sprites-right.png": 1139,
	"./images/pocket/frame-sprites/css_sprites.png": 1140,
	"./images/pocket/hero_en.jpg": 1141,
	"./images/pocket/hero_jp.jpg": 1142,
	"./images/pocket/icon-white.png": 1143,
	"./images/pocket/interface-1_en.jpg": 1144,
	"./images/pocket/interface-1_jp.jpg": 1145,
	"./images/pocket/interface-2_en.jpg": 1146,
	"./images/pocket/interface-2_jp.jpg": 1147,
	"./images/pocket/iphone-12-pro-max-frame-landscape.png": 337,
	"./images/pocket/iphone-12-pro-max-frame.png": 335,
	"./images/pocket/iphone-12-shadow-landscape.png": 342,
	"./images/pocket/iphone-12-shadow.png": 341,
	"./images/pocket/iphone-mask-landscape.svg": 338,
	"./images/pocket/iphone-mask.svg": 336,
	"./images/pocket/iphone-x-frame.png": 1148,
	"./images/pocket/iphone-x-shadow.png": 1149,
	"./images/pocket/multiphones-flat_en.jpg": 1150,
	"./images/pocket/multiphones-flat_jp.jpg": 1151,
	"./images/pocket/palette-capture-mask.svg": 1152,
	"./images/pocket/palette-capture_en.jpg": 1153,
	"./images/pocket/palette-capture_jp.jpg": 1154,
	"./images/pocket/placeholder-landscape.jpg": 1155,
	"./images/pocket/placeholder-portrait.jpg": 1156,
	"./images/pocket/pocket-10_en.jpg": 1157,
	"./images/pocket/pocket-10_jp.jpg": 1158,
	"./images/pocket/pocket-11_en.jpg": 1159,
	"./images/pocket/pocket-11_jp.jpg": 1160,
	"./images/pocket/pocket-12_en.jpg": 1161,
	"./images/pocket/pocket-12_jp.jpg": 1162,
	"./images/pocket/pocket-13_en.jpg": 1163,
	"./images/pocket/pocket-13_jp.jpg": 1164,
	"./images/pocket/pocket-14_en.jpg": 1165,
	"./images/pocket/pocket-14_jp.jpg": 1166,
	"./images/pocket/pocket-15_en.jpg": 1167,
	"./images/pocket/pocket-15_jp.jpg": 1168,
	"./images/pocket/pocket-16_en.jpg": 1169,
	"./images/pocket/pocket-16_jp.jpg": 1170,
	"./images/pocket/pocket-17_en.jpg": 1171,
	"./images/pocket/pocket-17_jp.jpg": 1172,
	"./images/pocket/pocket-1_en.jpg": 1173,
	"./images/pocket/pocket-1_jp.jpg": 1174,
	"./images/pocket/pocket-2_en.jpg": 1175,
	"./images/pocket/pocket-2_jp.jpg": 1176,
	"./images/pocket/pocket-3_en.jpg": 1177,
	"./images/pocket/pocket-4_en.jpg": 1178,
	"./images/pocket/pocket-4_jp.jpg": 1179,
	"./images/pocket/pocket-5_en.jpg": 1180,
	"./images/pocket/pocket-5_jp.jpg": 1181,
	"./images/pocket/pocket-6_en.jpg": 1182,
	"./images/pocket/pocket-6_jp.jpg": 1183,
	"./images/pocket/pocket-7_en.jpg": 1184,
	"./images/pocket/pocket-7_jp.jpg": 1185,
	"./images/pocket/pocket-9_en.jpg": 1186,
	"./images/pocket/pocket-9_jp.jpg": 1187,
	"./images/pocket/pocket-hero-mask.svg": 334,
	"./images/press/download-tile-bg-desktop_cn.jpg": 1188,
	"./images/press/download-tile-bg-desktop_en.jpg": 1189,
	"./images/press/download-tile-bg-desktop_jp.jpg": 1190,
	"./images/press/download-tile-bg-mobile_cn.jpg": 1191,
	"./images/press/download-tile-bg-mobile_en.jpg": 1192,
	"./images/press/download-tile-bg-mobile_jp.jpg": 1193,
	"./images/press/sheila.jpg": 1194,
	"./images/resources/be-kind-background.jpg": 1195,
	"./images/resources/link-faq-desktop_en.jpg": 1196,
	"./images/resources/link-faq-mobile_en.jpg": 1197,
	"./images/resources/link-handbook-desktop_cn.jpg": 1198,
	"./images/resources/link-handbook-desktop_en.jpg": 1199,
	"./images/resources/link-handbook-desktop_jp.jpg": 1200,
	"./images/resources/link-handbook-mobile_cn.jpg": 1201,
	"./images/resources/link-handbook-mobile_en.jpg": 1202,
	"./images/resources/link-handbook-mobile_jp.jpg": 1203,
	"./images/resources/link-learn-desktop_en.jpg": 1204,
	"./images/resources/link-learn-mobile_en.jpg": 1205,
	"./images/resources/link-pocket-desktop_cn.jpg": 1206,
	"./images/resources/link-pocket-desktop_en.jpg": 1207,
	"./images/resources/link-pocket-desktop_jp.jpg": 1208,
	"./images/resources/link-pocket-mobile_cn.jpg": 1209,
	"./images/resources/link-pocket-mobile_en.jpg": 1210,
	"./images/resources/link-pocket-mobile_jp.jpg": 1211,
	"./images/resources/support-bs-cta-desktop.jpg": 1212,
	"./images/resources/support-bs-cta-mobile.jpg": 1213,
	"./images/ui/frames/ipad/pro-5-gen-landscape-mask.png": 1214,
	"./images/ui/frames/ipad/pro-5-gen-landscape-solid.jpg": 1215,
	"./images/ui/frames/ipad/pro-5-gen-landscape.png": 329,
	"./images/ui/frames/ipad/pro-5-gen-portrait-mask.png": 1216,
	"./images/ui/frames/ipad/pro-5-gen-portrait-solid.jpg": 1217,
	"./images/ui/frames/ipad/pro-5-gen-portrait.png": 331,
	"./images/ui/shadows/ipad/pro-5-gen-landscape.png": 330,
	"./images/ui/shadows/ipad/pro-5-gen-portrait.png": 332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 591;